<template>
  <onboarding-container
    :width="1000"
    include-back-button
    @goBack="goBack"
    no-background
  >
    <b-steps
      v-model="currentStep"
      label-position="right"
      size="is-small"
      class="onboarding_steps with_white_content"
      vertical
      :has-navigation="false"
      :animated="false"
    >
      <b-step-item
        v-for="(step,index) in steps"
        :key="step.id"
        :value="step.id"
        :label="step.label"
        :step="index + 1"
        :clickable="true"
      >
        <component ref="stepComponent" v-bind:is="step.component"/>

        <div class="flex flex-between mt-200">
          <button-default @click="previousStep" :disabled="disablePreviousButton">Previous</button-default>
          <button-default @click="nextStep">Next</button-default>
        </div>
      </b-step-item>
    </b-steps>
  </onboarding-container>
</template>

<script>
import {defineComponent} from 'vue'
import OnboardingContainer from "./component/OnboardingContainer.vue";
import OnboardingStepLeadStatuses from "./steps/OnboardingStepLeadStatuses.vue";
import OnboardingStepContactTypes from "./steps/OnboardingStepContactTypes.vue";
import OnboardingStepCampaigns from "./steps/OnboardingStepCampaigns.vue";
import OnboardingStepFollowUpSequences from "./steps/OnboardingStepFollowUpSequences.vue";
import OnboardingStepInviteUser from "./steps/OnboardingStepInviteUser.vue";
import OnboardingStepLeadStatus from "./steps/OnboardingStepLeadStatuses.vue";

export default defineComponent({
  name: "OnboardingWizard1Page",
  components: {OnboardingStepLeadStatus, OnboardingContainer},
  metaInfo: {
    title: "Setup Account"
  },
  data() {
    return {
      currentStep: 'statuses',
    }
  },
  computed: {
    steps() {
      const steps = [
        {
          id: 'statuses',
          label: 'Lead Statuses',
          component: OnboardingStepLeadStatuses,
        },
        {
          id: 'types',
          label: 'Contact Types',
          component: OnboardingStepContactTypes,
        },
        {
          id: 'campaigns',
          label: 'Marketing Campaigns',
          component: OnboardingStepCampaigns,
        },
      ]

      if (this.$store.getters.account.has_follow_up_sequence_feature) {
        steps.push({
          id: 'sequences',
          label: 'Follow Up Sequences',
          component: OnboardingStepFollowUpSequences,
        })
      }

      if (this.$store.getters.account.has_invite_users_feature) {
        steps.push({
          id: 'invite',
          label: 'Invite Users',
          component: OnboardingStepInviteUser,
        })
      }

      return steps;
    },
    disablePreviousButton() {
      return this.currentStep === this.steps[0].id;
    },
  },
  methods: {
    goBack() {
      this.$router.push({name: 'onboarding-welcome'})
    },
    previousStep() {
      let currentIndex = this.steps.findIndex(step => step.id === this.currentStep);
      this.currentStep = this.steps[currentIndex - 1].id;
    },
    nextStep() {
      const stepsClone = [...this.steps];
      const lastStep = stepsClone.pop().id;

      if (this.currentStep === lastStep) {
        this.$router.push({name: 'onboarding-provisioning'})
      } else {
        let currentIndex = this.steps.findIndex(step => step.id === this.currentStep);
        this.currentStep = this.steps[currentIndex + 1].id;
      }
    }
  },
})
</script>
